import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { Tooltip } from "reactstrap";
import { useOfficeDetail } from "repositories/office-repository";
import useHandleApiError from "hooks/useHandleApiError";
import constants from "../../../../constants";
import defaultUserImage from "assets/images/staff-default.svg";
import Calendar_staff_details_listing from "assets/images/calendar_staff_details_listing.svg";
import Reports_To_staff_listing from "assets/images/Reports_To_staff_listing.svg";
import offices_icon_staff_listing from "assets/images/offices_icon_staff_listing.svg";
import moment from "moment";
import { MoreTagsFunction } from "accountOwner/pages/AddEvent/addEvents.functions";
import AssignedOfficeModal from "./AssignedOfficeModal";
import styles from "../../staff.module.scss";
import ActionModalWithModal from "./ActionModalWithModal";
import { cloneDeep } from "lodash";
import {
  commonSelectedIntial,
  setterCommonValues,
} from "./staffActions.function";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import staffIcon from "assets/images/staff-icon.svg";
export const StatusCard = ({
  timeSheet,
  type,
  t,
  addClass = "",
  spanClass,
  globalStaffPage,
}) => {
  const commonClass = addClass ? addClass : "ps-lg";
  switch (type) {
    case 1: {
      if (globalStaffPage) {
        return null;
      }
      return (
        <div className={"process d-flex justify-content-start " + commonClass}>
          <img
            src={require("assets/images/process-icon.svg").default}
            alt="staff"
          />
          <span className={spanClass}>
            <strong>{timeSheet || "-"}</strong> ({t("accountOwner.thisMonth")})
          </span>
        </div>
      );
    }
    case 2: {
      return (
        <div
          className={
            "process-pending d-flex justify-content-start " + commonClass
          }
        >
          <img
            src={require("assets/images/staff-deactivated.svg").default}
            alt="staff"
          />
          <span className={spanClass}>{t("accountOwner.deactivated")}</span>
        </div>
      );
    }

    case 3: {
      return (
        <div
          className={
            "process-pending d-flex justify-content-start " + commonClass
          }
        >
          <img
            src={require("assets/images/invitation-pending.svg").default}
            alt="staff"
          />
          <span className={spanClass}>
            {t("accountOwner.invitationPending")}
          </span>
        </div>
      );
    }
    case 4: {
      return (
        <div
          className={
            "process-decline d-flex justify-content-start " + commonClass
          }
        >
          <img
            src={require("assets/images/invite-declined.svg").default}
            alt="staff"
          />
          <span className={spanClass}>
            {t("accountOwner.invitationDeclined")}
          </span>
        </div>
      );
    }
    case 5: {
      return (
        <div
          className={
            "process-decline d-flex justify-content-start " + commonClass
          }
        >
          <img
            src={require("assets/images/staff-removed.svg").default}
            alt="staff"
          />
          <span className={spanClass}>{t("accountOwner.removedStaff")}</span>
        </div>
      );
    }

    default:
      return null;
  }
};
function StaffCard(props) {
  const [pmsConnectTooltip, setPmsConnectTooltip] = useState(false);
  const { profile,selectedOwnerIdString } = useAccountOwnerCommon();
  const {
    data: {
      profilePic,
      firstName,
      lastName,
      designation,
      timeSheet,
      isAdmin,
      staffRoleId,
      sikkaProviderId,
      isOwner,
      employmentDate,
      reportToName,
    },
    data,
    t,
    staffLogin,
    callApi,
    lastItem = false,
    globalStaffPage,
    selectedId,
    onSelect,
    isChecked,
    resetApi,
    setLoading,
    index,
    setterStaffList,
    staffListAllData,
    canSelectRef,
  } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const targetRef = useRef(null);
  const observerRef = useRef(null);
  const actionModalRef = useRef(null);

  const officeFirstData =
    data?.officeList?.length === 1 ? data.officeList[0] : null;
  const allTypeSame = data?.officeList?.length
    ? data?.officeList.reduce((prev, curr, i) => {
        if (!i) {
          prev = curr.type;
        }
        if (i && prev !== curr.type) {
          return 0;
        }
        return prev;
      }, 0)
    : 0;
  const type =
    data?.officeList?.length === 1
      ? data.officeList[0].type
      : data?.type || allTypeSame;
  const showIcon = [1, 2, 3].includes(type) || !type ? isAdmin : false;
  useEffect(() => {
    // if (!lastItem) return;
    const target = targetRef.current;
    if (lastItem) {
      observerRef.current = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            callApi();
          }
        },
        {
          root: null,
          threshold: 0.5,
        }
      );

      if (target) {
        observerRef.current.observe(target);
      }
    }

    return () => {
      if (target && observerRef.current) {
        observerRef.current.unobserve(target);
      }
    };
  }, [lastItem]);

  const {
    data: officeDetail,
    error: officeDetailError,
    isLoading: loadingOfficeDetails,
    isFetching: fetchingOfficeDetails,
  } = useOfficeDetail(props.OfficeId, { enabled: !globalStaffPage });
  const sortedData = useMemo(() => {
    // staff {type}
    // 1=> activated
    // 2=> deactivated
    // 3=> invitation pending
    // 4=> invitation declined
    // 5=> removed
    const initalData = cloneDeep(commonSelectedIntial);
    if (globalStaffPage) {
      return data.officeList.reduce((prev, curr) => {
        curr.staffMemberId = data.userId;
        setterCommonValues(prev, curr);
        return prev;
      }, initalData);
    }
    return initalData;
  }, [data, globalStaffPage]);

  const {
    selectedActivated,
    selectedDeactivated,
    selectedInvitationPendingWithouAdmin,
    selectedInvitationDeclinedWithouAdmin,
    selectedRemovedWithouAdmin,
  } = sortedData;
  useHandleApiError(
    loadingOfficeDetails,
    fetchingOfficeDetails,
    officeDetailError
  );

  const otherIcons = officeFirstData || !globalStaffPage || isOwner;
  const viewOrCanEdit = !(
    isOwner ||
    (staffLogin &&
      isAdmin &&
      !selectedActivated.length &&
      !selectedDeactivated.length &&
      !selectedInvitationPendingWithouAdmin.length &&
      !selectedInvitationDeclinedWithouAdmin.length &&
      !selectedRemovedWithouAdmin.length) ||
    (globalStaffPage && profile?.id === data.userId)
  );
  const isNotOwner = !isOwner;
  const getUniqueId = useCallback((item) => (globalStaffPage ? item?.userId : item?.staffMemberId), [globalStaffPage]);
  useEffect(() => {
    const uid = getUniqueId(data);
    if (viewOrCanEdit) {
      canSelectRef.current.set(uid, uid);
    } else {
      canSelectRef.current.delete(uid);
    }
  }, [viewOrCanEdit]);
  return (
    <div ref={actionModalRef} className="col-xl-3 col-lg-4 col-md-6">
    <Link
      to={{
        ...(viewOrCanEdit && {
          pathname: globalStaffPage
            ? constants.routes.staff.globaleStaffDetail
            : constants.routes.staff.staffDetail,
        }),
        state: {
          ...(props?.location?.state ?? {}),
          detail: props.data,
          OfficeId: props.OfficeId,
          officeData: {
            ...props?.location?.state?.officeData,
          },
          ...(globalStaffPage && { ownerId: selectedId }),
        },
        search:globalStaffPage&&selectedOwnerIdString?`?${selectedOwnerIdString}`:""
      }}
      ref={targetRef}
    >
      <div
        className={`staff-card ${type === 3 ? "pending-card" : ""} ${
          type === 4 ? "decline-card" : ""
        } ${type === 2 ? "deactivated-card" : ""}`}
      >
        <div className={styles.checkbox_icon_container + " align-items-center"}>
          <div
            className="ch-checkbox c-field m-0"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            {viewOrCanEdit && (
              <label>
                <input
                  type="checkbox"
                  checked={isChecked}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  onChange={(e) => {
                    onSelect(e, data);
                  }}
                />
                <span className="checkmark"></span>
              </label>
            )}
          </div>
          <div
            className={styles.icon_dropdown_container}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            {showIcon ? (
              <div
                className={"d-flex gap-xxs " + styles["staff-dropdown"]}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
              >
                <img
                  src={require("assets/images/admin-access.svg").default}
                  alt="icon"
                />
              </div>
            ) : null}
            {viewOrCanEdit && (
              <ActionModalWithModal
                ref={actionModalRef}
                type={type}
                officeId={props.OfficeId}
                detail={data}
                t={t}
                resetApi={resetApi}
                startLoading={() => setLoading(true)}
                stopLoading={() => setLoading(false)}
                globalStaffPage={globalStaffPage}
                index={index}
                setterStaffList={setterStaffList}
                staffListAllData={staffListAllData}
                officeData={{
                  ...props?.location?.state?.officeData,
                  ...officeDetail,
                }}
                selectedId={
                  globalStaffPage ? selectedId : officeDetail?.ownerId
                }
              />
            )}
          </div>
        </div>
        {sikkaProviderId && (
          <div className=" staff_office_tooltip">
            <div className="staff_tooltip_dentrix_wrapper">
              <img
                className="cursor-pointer"
                onClick={() => {
                  setPmsConnectTooltip(!pmsConnectTooltip);
                }}
                id="PmsConnectTooltip"
                src={require("assets/images/info_black-tooltip.svg").default}
                alt="icon"
              />
              <Tooltip
                className="new-item-card-catalogue-tooltip"
                isOpen={pmsConnectTooltip}
                placement="top"
                target="PmsConnectTooltip"
                toggle={() => {
                  setPmsConnectTooltip(!pmsConnectTooltip);
                }}
              >
                {t("pmsMembers.staffSyncedMsg", {
                  pmsName: officeDetail?.practiceManagementSystemName,
                })}
              </Tooltip>
              <span className="staff_dentrix_text">
                {officeDetail?.practiceManagementSystemName}
              </span>
            </div>
          </div>
        )}
        <div
          className={`${
            sikkaProviderId ? "card-content" : "card-content_not_present"
          }`}
        >
          <div className="staff-img mb-4">
            <div className="_img">
              {profilePic ? (
                <img
                  src={profilePic}
                  alt="staff"
                  onError={(e) => {
                    e.currentTarget.src = defaultUserImage;
                  }}
                />
              ) : (
                <img src={defaultUserImage} alt="staff" />
              )}
            </div>
            <span className="ico">
              {staffRoleId === 2 ? (
                <img
                  src={require("assets/images/star.svg").default}
                  alt="staff"
                />
              ) : staffRoleId === 1 ? (
                <img
                  src={require("assets/images/star-pending.svg").default}
                  alt="staff"
                />
              ) : null}
            </span>
          </div>
          <h4>
            {firstName} {lastName}
          </h4>
          {globalStaffPage && isNotOwner && (
            <div className="profile d-flex align-items-center justify-content-start ps-lg cfs-xs">
              <img src={offices_icon_staff_listing} alt="staff" />
              <MoreTagsFunction
                value={data.officeList}
                lastIndex={1}
                clickHandler={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  setIsModalOpen(true);
                }}
                mapFn={(member) =>
                  member?.officeName +
                  (otherIcons ? ` (${member?.designationName})` : "")
                }
                parentClass={"text-truncate"}
                hideMore={false}
              />
              {data.officeList?.length > 1 && (
                <>
                  ,
                  <span
                    type="button"
                    className={`link-btn`}
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      setIsModalOpen(true);
                    }}
                  >
                    +{data.officeList?.length - 1} More
                  </span>
                </>
              )}
              <AssignedOfficeModal
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                officeList={data.officeList}
                sikkaProviderId={sikkaProviderId}
                globalStaffPage={globalStaffPage}
              />
            </div>
          )}
          {otherIcons && isNotOwner && (
            <div className="profile d-flex align-items-center justify-content-start ps-lg cfs-xs">
              <img src={Reports_To_staff_listing} alt="staff" />
              <div className="wrapper-fix">
              <span>Reports To: </span>
              <b className="text-dark ml-1">
                {officeFirstData?.reportToName || reportToName || "--"}
              </b>
              </div>
            </div>
          )}
          {isOwner && (
            <div className="profile d-flex justify-content-start ps-lg">
              <img src={staffIcon} alt="staff" />
              <span className="ml-2">Owner</span>
            </div>
          )}
          {otherIcons && isNotOwner && (
            <div className="profile d-flex align-items-center justify-content-start ps-lg cfs-xs">
              <img src={Calendar_staff_details_listing} alt="staff" />
              <div className="wrapper-fix">
              <span>Employment Date: </span>
              <b className="text-dark ml-1">
                {officeFirstData?.employmentDate || employmentDate
                  ? moment(
                      officeFirstData?.employmentDate || employmentDate
                    ).format("MMM DD,YYYY")
                  : "--"}
              </b>
              </div>
            </div>
          )}
          {!globalStaffPage && isNotOwner && (
            <div className="profile d-flex justify-content-start ps-lg">
              <img src={staffIcon} alt="staff" />
              <span>{designation || "--"}</span>
            </div>
          )}
          {isNotOwner && (
            <StatusCard
              t={t}
              type={type}
              timeSheet={timeSheet}
              globalStaffPage={globalStaffPage}
            />
          )}
        </div>
      </div>
    </Link>
    </div>
  );
}

export default withTranslation()(StaffCard);
